import FilterHelper from "../../../helpers/filterHelper";
import { formatQueryStringURL } from "../../../helpers/formatQueryStringHelper";
import { axiosDelete, axiosGet, axiosPost, axiosPut } from "../../../services/axiosService";
const baseComparisonURL = 'CompetitorComparisons';

export class ComparisonService {
  getAllComparison(currentPage = 1, perPage = 10, filter) {
    let params = `?Paging.CurrentPage=${currentPage}&Paging.PerPage=${perPage}${filter ? `&${FilterHelper.mapToParams(filter, true)}` : ''
      }`;
    params = formatQueryStringURL(params);
    return axiosGet(null, baseComparisonURL + params);
  }

  getComparisonDetail(id) {
    return axiosGet(null, `${baseComparisonURL}/${id}`);
  }

  addComparison(formData) {
    return axiosPost(formData, baseComparisonURL);
  }

  updateComparison(id, formData) {
    return axiosPut(formData, `${baseComparisonURL}/${id}`);
  }

  deleteComparison(id) {
    return axiosDelete(`${baseComparisonURL}/${id}`);
  }

  syncComparison(blogId) {
    return axiosPost({}, `${baseComparisonURL}/${blogId}/SyncWithGlobal`);
  }
}